import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import VehicleDetail from "@/pages/VehicleDetail";
import Booking from "@/pages/Booking";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyBookings from "@/pages/MyBookings";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Gallery from "@/pages/Gallery";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import "@/App.css";

function Shell({ children, marketing = false }) {
  return (
    <div className={marketing ? "bg-[#040B16] text-white min-h-screen" : "bg-[#F5F5F5] text-[#0B1F3A] min-h-screen"}>
      <Navbar marketing={marketing} />
      <div className="pt-20">{children}</div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Shell marketing><Home /></Shell>} />
          <Route path="/fleet" element={<Shell marketing><Fleet /></Shell>} />
          <Route path="/vehicle/:id" element={<Shell marketing><VehicleDetail /></Shell>} />
          <Route path="/booking/:id" element={<Shell><Booking /></Shell>} />
          <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
          <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
          <Route path="/about" element={<Shell marketing><About /></Shell>} />
          <Route path="/services" element={<Shell marketing><Services /></Shell>} />
          <Route path="/contact" element={<Shell marketing><Contact /></Shell>} />
          <Route path="/faq" element={<Shell><FAQ /></Shell>} />
          <Route path="/gallery" element={<Shell marketing><Gallery /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route path="/my-bookings" element={<Shell><MyBookings /></Shell>} />
          <Route path="/admin" element={<Shell><Admin /></Shell>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
